const ASSEMBLY_CALENDAR_TIMEZONE = 'UTC';

const normalizeAssemblyDate = (dateValue: Date | string): Date | null => {
  if (dateValue instanceof Date) {
    return Number.isNaN(dateValue.getTime()) ? null : dateValue;
  }

  if (typeof dateValue !== 'string') {
    return null;
  }

  const trimmedDate = dateValue.trim();
  if (!trimmedDate) {
    return null;
  }

  const dateOnlyMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnlyMatch) {
    const year = Number(dateOnlyMatch[1]);
    const month = Number(dateOnlyMatch[2]);
    const day = Number(dateOnlyMatch[3]);
    const utcDate = new Date(Date.UTC(year, month - 1, day));
    return Number.isNaN(utcDate.getTime()) ? null : utcDate;
  }

  const parsedDate = new Date(trimmedDate);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const formatAssemblyCalendarDateEs = (
  dateValue: Date | string,
  fallback = 'Por definir'
): string => {
  const parsedDate = normalizeAssemblyDate(dateValue);
  if (!parsedDate) {
    return fallback;
  }

  return parsedDate.toLocaleDateString('es-ES', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: ASSEMBLY_CALENDAR_TIMEZONE,
  });
};

export const formatAssemblyTimeEs = (
  timeValue?: string,
  fallback = 'Por confirmar'
): string => {
  if (!timeValue) {
    return fallback;
  }

  const [hours, minutes] = timeValue.slice(0, 5).split(':').map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return fallback;
  }

  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${String(minutes).padStart(2, '0')} ${ampm}`;
};

export const getAssemblyDateTimeMillis = (
  scheduledDate: Date | string,
  startTime?: string
): number => {
  const parsedDate = normalizeAssemblyDate(scheduledDate);
  if (!parsedDate) {
    return Number.MAX_SAFE_INTEGER;
  }

  const [hours, minutes] = (startTime || '00:00').slice(0, 5).split(':').map(Number);
  const safeHours = Number.isNaN(hours) ? 0 : Math.min(Math.max(hours, 0), 23);
  const safeMinutes = Number.isNaN(minutes) ? 0 : Math.min(Math.max(minutes, 0), 59);

  const dateTime = new Date(parsedDate.getTime());
  dateTime.setUTCHours(safeHours, safeMinutes, 0, 0);
  return dateTime.getTime();
};
